import { useState, useRef } from 'react'
import styles from './styles.module.css'
import Masonry from 'react-responsive-masonry'
import {
  CircleX,
  Interrogation,
  Cross,
} from '../../assets/svgs/icons'
import InputSearch from '../InputSearch'
import Loading from '../Loading'
import {
  FreepikService,
  PexelsService,
  SubscriptionService,
} from '../../services/'
import { useTranslation } from 'react-i18next'
import { notifyErrorCustom } from '../../utils/notify'
import ModalWarninFreepik from '../ModalWarningFreepik'

export const ModalImageBank = ({ onClose, onSave }) => {
  const { t } = useTranslation()
  const carouselRef = useRef(null)
  const [isDragging, setIsDragging] = useState(false)
  const [startX, setStartX] = useState(null)
  const [scrollLeft, setScrollLeft] = useState(0)

  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [allImages, setAllImages] = useState([])
  const [openModalFreepik, setOpenModalFreepik] = useState(false)
  const [noResultString, setNoResultString] = useState('')
  const [selectedImages, setSelectedImages] = useState([])
  const [selectedArrayImage, setSelectedArrayImage] = useState([])

  const handleLoadImages = async () => {
    if (!search.trim()) {
      notifyErrorCustom('Digite algo para pesquisar')
      return
    }

    setLoading(true)
    setNoResultString('')
    
    const subscription = await SubscriptionService.getSubscriptionByUser()
    let response

    if (subscription.data.length > 0) {
      const body = {
        search: search,
        limit: 10,
      }
      try {
        response = await FreepikService.getFreepikImages(body)
        if (response.responseStatus !== 200) {
          setOpenModalFreepik(true)
          setLoading(false)
          return
        }
      } catch (error) {
        setOpenModalFreepik(true)
        setLoading(false)
        return
      }
    } else {
      const body = {
        search: search,
        limit: 10,
      }
      try {
        response = await PexelsService.postPexelsImages(body)
      } catch (error) {
        setOpenModalFreepik(true)
        setLoading(false)
        return
      }
    }

    if (response.data) {
      let newResponseData = response.data.map((image, index) => {
        return {
          id: index,
          url: image.imageUri || image.imageUrl || image.imageUr,
          base64: image.imageBase64 ?? null,
          idFreepik: image.id ?? '',
        }
      })

      if (newResponseData.length <= 0) {
        setNoResultString('Nenhum Resultado Encontrado!')
      }

      setAllImages(newResponseData)
    }

    setLoading(false)
  }

  const handleImageClick = (imageUrl) => {
    if (selectedImages.length >= 1) {
      if (imageUrl.id !== selectedImages[0]) {
        notifyErrorCustom('Você só pode selecionar uma imagem por vez.')
      }
      return
    }

    const imageArray = allImages.find((image) => image.id === imageUrl.id)

    if (imageArray) {
      const arrayExists = selectedArrayImage.some(
        (arr) => JSON.stringify(arr) === JSON.stringify(imageArray)
      )

      if (arrayExists) {
        setSelectedArrayImage(
          selectedArrayImage.filter(
            (arr) => JSON.stringify(arr) !== JSON.stringify(imageArray)
          )
        )
      } else {
        setSelectedArrayImage([...selectedArrayImage, imageArray])
      }
    }

    if (selectedImages.includes(imageUrl.id)) {
      setSelectedImages(selectedImages.filter((image) => image !== imageUrl.id))
    } else {
      setSelectedImages([...selectedImages, imageUrl.id])
    }
  }

  const handleRemoveImage = (imageArray) => {
    setSelectedArrayImage(
      selectedArrayImage.filter(
        (arr) => JSON.stringify(arr) !== JSON.stringify(imageArray)
      )
    )

    if (selectedImages.includes(imageArray.id)) {
      setSelectedImages(
        selectedImages.filter((image) => image !== imageArray.id)
      )
    }
  }

  const addImages = async () => {
    const imagesToAdd = selectedArrayImage.map((image) => {
      if (image.base64) {
        return {
          id: image.id,
          fileDataBase64: 'data:image/png;base64,' + image.base64,
          image: 'data:image/png;base64,' + image.base64,
          source: 'imageBank',
          base64: image.base64,
          idFreepik: image.idFreepik,
        }
      } else if (image.url) {
        return {
          id: image.id,
          fileDataBase64: image.url,
          image: image.url,
          url: image.url,
          source: 'imageBank',
          idFreepik: image.idFreepik,
        }
      } else {
        return {
          id: image.id,
          source: 'imageBank',
          idFreepik: image.idFreepik,
        }
      }
    })

    if (onSave) {
      onSave(imagesToAdd)
    }
    if (onClose) {
      onClose()
    }
  }

  const handleMouseDown = (event) => {
    setIsDragging(true)
    setStartX(event.clientX - carouselRef.current.offsetLeft)
    setScrollLeft(carouselRef.current.scrollLeft)
    carouselRef.current.style.scrollBehavior = 'unset'
  }

  const handleMouseMove = (event) => {
    if (!isDragging) return
    const x = event.clientX - carouselRef.current.offsetLeft
    const scrollOffset = (x - startX) * 1.0
    carouselRef.current.scrollLeft = scrollLeft - scrollOffset
  }

  const handleMouseUp = () => {
    setIsDragging(false)
    if (carouselRef.current) {
      carouselRef.current.style.scrollBehavior = 'smooth'
    }
  }

  const handleCloseModal = () => {
    setOpenModalFreepik(false)
  }

  return (
    <div className={styles.modal}>
      <Loading enable={loading} />
      <ModalWarninFreepik
        isOpen={openModalFreepik}
        onClose={() => handleCloseModal()}
        handleCloseModal={handleCloseModal}
        type={'bi'}
      />

      <div className={styles.modal_title}>
        <h2 className={styles.modal_title_text}>
          {t('new_publication_page_second_pass_bank_of_image_page_text') || 'Banco de Imagens'}
          <Interrogation color={'#FF8B00'} width={18} height={18} />
        </h2>
      </div>

      <div className={styles.modal_sub_title}>
        <p className={styles.modal_sub_title_text}>
          {t('new_publication_page_second_pass_bank_of_image_page_subtitle') || 'Busque e selecione imagens do banco'}
        </p>
      </div>

      <div className={styles.filters}>
        <div className={styles.search_images}>
          <InputSearch
            placeholder={
              t('new_publication_page_second_pass_bank_of_image_page_input_placeholder') ||
              'Digite o que deseja buscar'
            }
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onSearch={async () => {
              setLoading(true)
              await handleLoadImages()
            }}
            style={{
              color: '#ffffff',
            }}
          />
        </div>
      </div>

      <div className={styles.box_container_galery_of_image}>
        <div className={styles.container_galery_of_image}>
          {allImages.length > 0 && (
            <Masonry columnsCount={3} gutter="10px">
              {allImages.map((imageUrl, i) => (
                <img
                  key={i}
                  src={
                    imageUrl.base64
                      ? 'data:image/png;base64,' + imageUrl.base64
                      : imageUrl.url
                  }
                  onClick={() => handleImageClick(imageUrl)}
                  className={
                    selectedImages.includes(imageUrl.id)
                      ? styles.selectedImage
                      : styles.image
                  }
                  alt="bank-image"
                />
              ))}
            </Masonry>
          )}
          {allImages.length <= 0 && (
            <p className={styles.no_images_text}>
              {noResultString || 'Digite algo para buscar imagens'}
            </p>
          )}
        </div>
      </div>

      {selectedArrayImage.length !== 0 && (
        <div className={styles.container_list_selected_image}>
          <p className={styles.selected_images_title}>Imagens Adicionadas</p>
          <div
            className={styles.content_list_selected_image}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
          >
            <div
              className={styles.caroucel_list_selected_image}
              ref={carouselRef}
            >
              {selectedArrayImage.map((imageArray) => (
                <div
                  className={styles.card_lis_selected_image}
                  key={imageArray.id}
                >
                  <div className={styles.container_card_lis_selected_image}>
                    <div
                      className={styles.delete_card_lis_selected_image}
                      onClick={() => handleRemoveImage(imageArray)}
                    >
                      <div style={{ cursor: 'pointer' }}>
                        <CircleX
                          color={'#FF2F00'}
                          width={'15px'}
                          height={'15px'}
                        />
                      </div>
                    </div>
                    <img
                      className={styles.item_selected_image}
                      src={
                        imageArray.base64
                          ? 'data:image/png;base64,' + imageArray.base64
                          : imageArray.url
                      }
                      alt="selected"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <button
            className={styles.button_add_image}
            onClick={() => {
              addImages()
            }}
          >
            {t('new_publication_page_second_pass_bank_of_image_page_add_image') || 'Adicionar Imagens'}
          </button>
        </div>
      )}
    </div>
  )
}

export default ModalImageBank
